import { z } from "zod";
import { components } from "@opstel/gen/api/v2";

export interface ScenarioBorderTrain {
  id: string;
  name: string;
  track: string;
  trainUnitTypes?: string;
}

export const scenarioBorderTrainSchema = z.object({
  id: z.string(),
  name: z.string(),
  track: z.string(),
  trainUnitTypes: z.string().optional(),
}) satisfies z.ZodType<ScenarioBorderTrain, components["schemas"]["ScenarioBorderTrain"]>;
